/**
 * The web origin for any URL that LEAVES the app: a share link, a callback
 * handed to a third party (didit), an email link.
 *
 * In the native shell `window.location.origin` is `capacitor://localhost`,
 * which nobody outside the device can open. `build:native` bakes
 * `VITE_WEB_ORIGIN=https://worldby.me`; the web build leaves it unset and the
 * page's own origin is right. Same-origin checks and API-base fallbacks keep
 * using `location.origin` — this is only for URLs someone else will open.
 */
export function webOrigin(): string {
  const baked = import.meta.env.VITE_WEB_ORIGIN as string | undefined;
  return baked ? baked.replace(/\/+$/, "") : window.location.origin;
}
